let nmTargetDropdown = null
let nmTargetButtons  = null
let nmTargets        = null


export function initialize() {

  // Gather up all of the elements we'll work on.
  nmTargetDropdown = document.querySelector('#newsletter-targets')
  nmTargetButtons  = document.querySelectorAll('button[value^="newsletter-target-"]')
  nmTargets        = document.querySelectorAll('[id^="newsletter-target-"]')

  // Stop everything if any of the above elements do not exist.
  if (!nmTargetDropdown || !nmTargetButtons || !nmTargets) return

  // Initialize the page's default state: all targets hidden *except* the first one.
  nmTargets.forEach(function(element) {
    if (element.id !== 'newsletter-target-1') {
      element.setAttribute('hidden', 'true')
    }
  })

  // Move onto adding event listeners.
  addListeners()

}


export function addListeners() {

  // Listen for changes to the select dropdown.
  nmTargetDropdown.addEventListener('change', handleTargets, false)

  // Listen for a click on each button.
  nmTargetButtons.forEach(function(element) {
    element.addEventListener('click', handleTargets, false)
  })

}


export function handleTargets(event) {

  // Ensure the right button is rendered as 'selected'.
  nmTargetButtons.forEach(function(element) {
    if (element !== event.target) {
      element.parentNode.classList.remove('selected')
    } else {
      element.parentNode.classList.add('selected')
    }
  })

  // Ensure the right target is made visible.
  nmTargets.forEach(function(element) {
    if (element.id !== event.target.value) {
      element.setAttribute('hidden', 'true')
    }
    else {
      element.removeAttribute('hidden')
    }
  })

}
